export default {
  unWatchInstance(eventBusWatchInstances) {
    setTimeout(() => {
      if (eventBusWatchInstances) {
        eventBusWatchInstances.forEach((watchInstance) => {
          watchInstance();
        });
      }
    }, 200);
  },
};
